import { render, staticRenderFns } from "./MarkList.vue?vue&type=template&id=389b8a62&scoped=true&"
import script from "./MarkList.vue?vue&type=script&lang=js&"
export * from "./MarkList.vue?vue&type=script&lang=js&"
import style0 from "./MarkList.vue?vue&type=style&index=0&id=389b8a62&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "389b8a62",
  null
  
)

export default component.exports